export default "__VITE_ASSET__2e88f2fb__"